import './component.scss';

export class CatalogElement {

    constructor(id, params = {}, result = {}, options = {}, JCCatalogElement = {}) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.JCCatalogElement = JCCatalogElement
        this.$component = document.getElementById(this.id)

        this.init()
    }

    init() {
        this.addObservers()
        this.initSlider()
        this.initFancybox()
    }

    addObservers() {
        BX.addCustomEvent('onCatalogElementChangeOffer', eventData => {
            // console.log('onCatalogElementChangeOffer')
            // console.log('eventData =', eventData)
            // console.log('offerId =', eventData.newId)
            // console.log('offerNum =', this.JCCatalogElement.offerNum)
            // console.log('offer.ID =', this.JCCatalogElement.offers[this.JCCatalogElement.offerNum].ID)
            // console.log('offer =', this.JCCatalogElement.offers[this.JCCatalogElement.offerNum])

            this.changeInfo(this.JCCatalogElement.offers[this.JCCatalogElement.offerNum])
        })
    }

    initSlider() {
        this.thumbsPictures = new Swiper('.js-product-mini-slider', {
            slidesPerView: 5,
            direction: 'vertical',
            spaceBetween: 20,
            navigation: {
                nextEl: '.js-product-mini-slider-next',
                prevEl: '.js-product-mini-slider-prev',
            },
        })

        this.cartImageSlider = new Swiper('.js-product-big-slider', {
            navigation: {
                nextEl: '.js-product-big-slider-next',
                prevEl: '.js-product-big-slider-prev',
            },
            thumbs: {
                swiper: this.thumbsPictures
            },
            pagination: {
                el: ".js-product-big-slider-pagination",
                clickable: true,
            },
        })
    }

    initFancybox() {
        Fancybox.bind('[data-fancybox="gallery"]', {
            mainClass: "big-slider",
            dragToClose: false,
            Toolbar: false,
            closeButton: "top",
            Image: {
                zoom: false,
            },
            on: {
                initCarousel: (fancybox) => {
                    const slide = fancybox.Carousel.slides[fancybox.Carousel.page];

                    fancybox.$container.style.setProperty(
                        "--bg-image",
                        `url("${slide.$thumb.src}")`
                    );
                },
                "Carousel.change": (fancybox, carousel, to, from) => {
                    const slide = carousel.slides[to];

                    fancybox.$container.style.setProperty(
                        "--bg-image",
                        `url("${slide.$thumb.src}")`
                    );
                },
            },
        });
    }

    changeInfo(offer) {
        this.changePictures(offer)
        this.changeInfoName(offer)
        this.changeInfoArticle(offer)
        this.changeInfoAvailableSizes(offer)
        this.changeBuyBtn(offer)
        this.changeCallBackFormData(offer)
        this.changePreorderFormData(offer)
        this.changeInfoTabProperties(offer)
        this.changeInfoTabRests(offer)
    }

    changePictures(offer) {
        if (!offer?.MORE_PHOTO) {
            return
        }

        this.thumbsPictures.removeAllSlides()
        this.cartImageSlider.removeAllSlides()

        if (0 < offer.MORE_PHOTO.length) {
            let newThumbs = []
            let newImages = []
            for (let image of offer.MORE_PHOTO) {
                newThumbs.push(`<div class="swiper-slide product-pic">
<img src="${image.SMALL_SRC}" itemprop="contentUrl" alt="${offer.NAME} ${offer.ARTICLE}">
</div>`)
                newImages.push(`<a class="swiper-slide product-pic" data-fancybox="gallery" href="${image.BIG_SRC}">
<img src="${image.MEDIUM_SRC}" alt="${offer.NAME} ${offer.ARTICLE}">
</a>`)
            }

            this.thumbsPictures.addSlide(1, newThumbs)
            this.cartImageSlider.addSlide(1, newImages)
        }
    }

    changeInfoName(offer) {
        if (!offer?.NAME) {
            return
        }

        this.$component.querySelector('.js-offers-name').innerHTML = offer?.NAME.trim()
    }

    changeInfoArticle(offer) {
        if (0 === this.$component.querySelectorAll('.js-offers-article').length) {
            return
        }

        if (!offer?.ARTICLE) {
            this.$component.querySelector('.js-offers-article').parentNode.style.display = 'none'
        } else {
            this.$component.querySelector('.js-offers-article').parentNode.style.display = 'block'
            this.$component.querySelector('.js-offers-article').innerHTML = offer?.ARTICLE.trim()
        }
    }

    changeInfoAvailableSizes(offer) {
        if (0 === this.$component.querySelectorAll('.js-availible-sizes').length) {
            return
        }

        setTimeout(() => {
            let values = []
            let $property = this.$component.querySelector('[data-entity="sku-line-block"][data-code="RAZMER"]')
            if (!$property) {
                return
            }

            let $options = $property.querySelectorAll('label.option:not(.notallowed)')
            if (0 === $options.length) {
                return
            }

            for (var $option of $options) {
                values.push($option.getAttribute('title'))
            }
            if (0 === $options.length) {
                return
            }

            this.$component.querySelector('.js-availible-sizes').innerHTML = values.join(', ').trim()

        }, 250)
    }

    changeBuyBtn(offer) {
        let $form = this.$component.querySelector('.js-offers-buyForm')
        if (!$form) {
            return
        }

        $form.dataset.productUrl = offer.DETAIL_PAGE_URL
        $form.dataset.productId = offer.ID
        $form.dataset.productName = offer.PRODUCT_NAME
        $form.dataset.productCategory = offer.SECTION_NAME
        $form.dataset.productPrice = offer.ITEM_PRICES[offer.ITEM_PRICE_SELECTED].PRICE
        $form.dataset.productPosition = 1

        if (0.0 < Number.parseFloat(offer.CATALOG_QUANTITY)) {
            $form.classList.remove('hidden')
        } else {
            $form.classList.add('hidden')
        }

        // change
        $form.setAttribute('onclick', '');
        $form.innerHTML = $form.dataset.labelTobasket;
        $form.classList.remove('product-page__button_hover');
        $form.classList.remove('js-added');
    }

    changeCallBackFormData(offer) {
        let $form = this.$component.querySelector('.js-detail-callback-form')
        if (!$form) {
            return
        }

        $form.querySelector('[name="CALLBACK_PRODUCT_ID"]').value = offer.ID
        $form.querySelector('[name="CALLBACK_PRODUCT_NAME"]').value = offer.NAME
        $form.querySelector('[name="CALLBACK_PRODUCT_ARTICLE"]').value = offer.ARTICLE
    }

    changePreorderFormData(offer) {
        let $form = this.$component.querySelector('.js-detail-preorder-form')
        if (!$form) {
            return
        }

        $form.querySelector('[name="PREORDER_PRODUCT_ID"]').value = offer.ID

        if (0 < offer.CATALOG_QUANTITY) {
            $form.classList.add('hidden')
        } else {
            $form.classList.remove('hidden')
        }
    }

    changeInfoTabProperties(offer) {
        let $rows = this.$component.querySelectorAll('.js-offers-props'),
            productId = 0

        for (var row of $rows) {
            if (true === row.classList.contains('hidden')) {
                continue
            }

            row.classList.add('hidden')
        }

        if (0 < this.$component.querySelectorAll(`.js-offers-props-item-id--${offer.ID}`).length) {
            this.$component.querySelector(`.js-offers-props-item-id--${offer.ID}`).classList.remove('hidden')
        }
    }

    changeInfoTabRests(offer) {
        let $rows = this.$component.querySelectorAll('.js-offers-rest'),
            productId = 0

        for (var row of $rows) {
            if (true === row.classList.contains('hidden')) {
                continue
            }

            row.classList.add('hidden')
        }

        if (0 < this.$component.querySelectorAll(`.js-offers-rest-item-id--${offer.ID}`).length) {
            this.$component.querySelector(`.js-offers-rest-item-id--${offer.ID}`).classList.remove('hidden')
        }
    }
}
